// @flow
import React from 'react';
import { Query, type QueryRenderProps } from '@apollo/client/react/components';

import CREATE_CLIENT_GUSTO_ACCOUNT from './queries';
import GustoAccountCreateStatus from './GustoAccountCreateStatus';
import GustoLoading from './GustoLoading';

export const GUSTO_LOGIN_REDIRECT = 'https://app.gusto.com/login';

type GustoRedirectUrl = {
  redirectUrl: string,
};

type CreateGustoAccountResponse = {
  createGustoAccount: GustoRedirectUrl,
};

type GustoPageContainerProps = {
  clientId: string,
};

const GustoPageContainer = ({ clientId }: GustoPageContainerProps) => (
  <Query query={CREATE_CLIENT_GUSTO_ACCOUNT} notifyOnNetworkStatusChange variables={{ clientId }}>
    {({
      data,
      loading,
      error,
      refetch,
      networkStatus,
    }: QueryRenderProps<CreateGustoAccountResponse>) => {
      const isRefetching = networkStatus === 4;

      if (isRefetching || loading) {
        return <GustoLoading />;
      }

      const redirectUrl = data && data.createGustoAccount && data.createGustoAccount.redirectUrl;

      if (redirectUrl) {
        window.open(redirectUrl, '_blank');
        return (
          <GustoAccountCreateStatus
            buttonText="Go to Gusto"
            descriptionText="Your Gusto account was successfully created, click below to complete setup"
            onClickButton={() => window.open(redirectUrl, '_blank')}
          />
        );
      }

      if (!redirectUrl && !error) {
        return (
          <GustoAccountCreateStatus
            buttonText="Log In to Your Gusto Account"
            descriptionText="Looks like you already have an account with Gusto"
            onClickButton={() => window.open(GUSTO_LOGIN_REDIRECT, '_blank')}
          />
        );
      }

      return (
        <GustoAccountCreateStatus
          buttonText="Try Connecting Again"
          descriptionText="Sorry, we’re having trouble connecting to Gusto; if you continue to have trouble setting up your account, please reach out to your Bench bookkeeper"
          onClickButton={() => refetch()}
        />
      );
    }}
  </Query>
);

export default GustoPageContainer;
